import type { EntityKind } from '@/types/identity';
import { ReportEventType, type ReportEvent } from '@/types/report';
import { getEntityKindForClass } from '@/utils/detection-classes';

function isUndefinedOfKind(event: ReportEvent, kind: EntityKind): boolean {
    return (
        event.eventType !== ReportEventType.CUSTOM &&
        event.identityId === null &&
        getEntityKindForClass(event.classId) === kind
    );
}

export function countUndefinedEventsByKind(
    events: ReportEvent[],
): Record<EntityKind, number> {
    return {
        person: events.filter((event) => isUndefinedOfKind(event, 'person'))
            .length,
        vehicle: events.filter((event) => isUndefinedOfKind(event, 'vehicle'))
            .length,
    };
}
